import { render, staticRenderFns } from "./LookingFor.vue?vue&type=template&id=1bc020a1&scoped=true&"
import script from "./LookingFor.vue?vue&type=script&lang=js&"
export * from "./LookingFor.vue?vue&type=script&lang=js&"
import style0 from "./LookingFor.vue?vue&type=style&index=0&id=1bc020a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc020a1",
  null
  
)

export default component.exports